import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { CreateUserFlowDraft } from '@features/users/interfaces';

/**
 * Subject service to listen to draft changes
 */
@Injectable({
    providedIn: 'root',
})
export class DraftSubject {
    /**
     * Subject to listen to draft changes
     *
     * @remarks
     * It takes the draft and a callback function as parameters
     */
    private draftSubject = new Subject<{ draft: CreateUserFlowDraft; fn?: () => void }>();

    /**
     * Getter the draft subject
     *
     * @returns The draft subject
     */
    public getDraftSubject(): Subject<{ draft: CreateUserFlowDraft; fn?: () => void }> {
        return this.draftSubject;
    }

    /**
     * Emit new draft data
     *
     * @param draft The draft data to emit
     * @param fn The callback function to execute after emitting the draft data
     */
    public next(draft: CreateUserFlowDraft, fn?: () => void): void {
        this.draftSubject.next({ draft, fn });
    }
}
